
import { defineComponent } from "vue";
import Spinner from "@/components/ui/Spinner.vue";

export default defineComponent({
  name: "RequestProcessing",
  components: { Spinner },
});
